import { render, staticRenderFns } from "./TransferCancellation.vue?vue&type=template&id=3167aeda"
import script from "./TransferCancellation.vue?vue&type=script&lang=js"
export * from "./TransferCancellation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports